"use client";

interface VideoCardProps {
  url: string;
  videoId: string;
}

export function VideoCard({ videoId }: VideoCardProps) {
  return (
    <div className="shrink-0 w-[280px] sm:w-[320px] aspect-[9/16] bg-gray-900 rounded-[2.5rem] overflow-hidden border-8 border-gray-900 shadow-2xl flex items-center justify-center relative">
      {/* Notch/Island Area (Cosmetic) */}
      <div className="absolute top-0 inset-x-0 h-7 bg-gray-900 z-20 flex justify-center pointer-events-none">
        <div className="w-24 h-5 bg-black rounded-b-xl" />
      </div>

      <div className="w-full h-full bg-black overflow-hidden rounded-[2rem]">
        <iframe
          src={`https://www.tiktok.com/embed/v2/${videoId}?lang=en-US`}
          className="w-full h-full border-0"
          scrolling="no"
          allowFullScreen
          title="TikTok Video"
        />
      </div>
    </div>
  );
}
